export function extractVimeoID2(url: string) {
  const regex = /vimeo\.com\/video\/(\d+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

export function extractVimeoID1(url: string) {
  const regex = /vimeo\.com\/(\d+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

export function isValidURL(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
  } catch (_) {
    return false;
  }
}

export function capitalizeFirstLetter(str: string) {
  return str[0].toUpperCase() + str.slice(1);
}

export function downloadFile(url: string, filename?: string) {
  const link = document.createElement('a');
  link.href = url;
  if (filename) link.download = filename;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const normalize = (str?: string | null): string =>
  str?.toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase() || "";

/** Safe Axios error status — avoids throw when `error.request` is missing. */
export function getRequestErrorCode(error: any): number {
  return error?.response?.status ?? error?.request?.status ?? 0;
}